import script from "./ClientRegist.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientRegist.vue?vue&type=script&setup=true&lang=ts"

import "./ClientRegist.vue?vue&type=style&index=0&id=d3fbbc7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3fbbc7a"]])

export default __exports__